import { Button, Flex, InputGroup, Text, AccordionItem, AccordionPanel, AccordionButton, useToast } from '@chakra-ui/react'
import React from 'react'
import { Input } from '../../../components/Form'
import { useFormContext, Controller } from 'react-hook-form'
import { TextEditor } from '../../../components/TextEditor'
import { FaRegTrashAlt } from 'react-icons/fa'
import { useState } from 'react'

export const ItemPerguntasResposta = ({ remove, index, field, onDelete }) => {
  const {
    register,
    formState: { errors },
    control,
  } = useFormContext()

  const toast = useToast({
    position: 'top-right',
    isClosable: true,
  })

  const [isLoading, setIsLoading] = useState(false)

  async function handleRemove(id, e) {
    e.stopPropagation()

    setIsLoading(true)

    if (!id) return remove(index)

    const res = await onDelete({ id })

    if (!res) {
      toast({
        title: 'Erro!',
        description: 'Erro ao remover pergunta e resposta!',
        status: 'error',
      })

      setIsLoading(false)

      return
    }

    if (res) {
      toast({
        title: 'Sucesso!',
        description: 'Pergunta e resposta removida com sucesso!',
        status: 'success',
      })

      remove(index)

      setIsLoading(false)
    }
  }

  return (
    <AccordionItem gap={2} w="full" justifyContent="space-between" alignItems="start">
      <Flex flexDir="column" gap={2} w="full">
        <AccordionButton
          bgColor={errors?.perguntas_respostas?.[index]?.pergunta ? 'red.100' : 'white'}
          _focus={{ outline: 'none', boxShadow: 'none' }}
          px={1}
          alignItens="center"
          justifyContent="space-between"
          gap={2}
        >
          <Text fontSize="lg" color="gray.800" fontWeight="semibold">
            {field.pergunta ? field.pergunta : ` Pergunta e Resposta - ${index + 1}`}
          </Text>
          <Button isLoading={isLoading} colorScheme="red" size="sm" onClick={(e) => handleRemove(field.pergunta_id, e)}>
            <FaRegTrashAlt />
          </Button>
        </AccordionButton>
        <AccordionPanel px={0} display="flex" flexDir="column" gap={2}>
          <input type="hidden" {...register(`perguntas_respostas.${index}.pergunta_id`)} />
          <InputGroup display="flex" flexDir="column" gap={1}>
            <Input
              error={errors?.perguntas_respostas?.[index]?.pergunta}
              id={`perguntas_respostas.${index}.pergunta`}
              {...register(`perguntas_respostas.${index}.pergunta`)}
              placeholder="Pergunta"
            />
            <Text fontSize="sm" color="red.500">
              {errors?.perguntas_respostas?.[index]?.pergunta?.message}
            </Text>
          </InputGroup>
          <Flex flexDir="column" gap={2} w="full">
            <InputGroup display="flex" flexDir="column" bg="white" gap={1} pb="10">
              <Controller
                name={`perguntas_respostas.${index}.resposta`}
                control={control}
                render={({ field }) => (
                  <TextEditor
                    name={`perguntas_respostas.${index}.resposta`}
                    {...field}
                    error={errors?.perguntas_respostas?.[index]?.resposta}
                    placeholder="Resposta"
                  />
                )}
              />
            </InputGroup>
            <Text fontSize="sm" color="red.500">
              {errors?.perguntas_respostas?.[index]?.resposta?.message}
            </Text>
          </Flex>
        </AccordionPanel>
      </Flex>
    </AccordionItem>
  )
}
